export default __webpack_public_path__ + "static/vrlife-5226a95a2ceb51cf8e782cb685511118.png";